export default "__VITE_PUBLIC_ASSET__e0990b8f__"